import React from 'react';

// Client logos via simpleicons.org CDN — chosen brands verified to render
const clients = [
  { name: 'Infosys', slug: 'infosys' },
  { name: 'SAP', slug: 'sap' },
  { name: 'Databricks', slug: 'databricks' },
  { name: 'Zendesk', slug: 'zendesk' },
  { name: 'HubSpot', slug: 'hubspot' },
  { name: 'TCS', slug: 'tcs' },
  { name: 'Snowflake', slug: 'snowflake' },
  { name: 'Intel', slug: 'intel' },
  { name: 'Cisco', slug: 'cisco' },
  { name: 'MongoDB', slug: 'mongodb' },
  { name: 'Atlassian', slug: 'atlassian' },
  { name: 'Cloudera', slug: 'cloudera' },
];

export default function ClientLogos() {
  return (
    <section className="bg-[#0F1C40] text-[#F1EDE4] py-20 lg:py-28 border-t border-white/10 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Trusted by</span>
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif italic text-[#4ECDC4] leading-[1.02]">
              We drive growth for the
              <br />
              <span className="text-[#F1EDE4]">world&apos;s leading B2B brands</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {clients.map((c) => (
            <div key={c.name} className="bg-white flex items-center justify-center h-28 lg:h-32 hover:bg-[#F1EDE4] transition-colors duration-300 group p-6">
              <img
                src={`https://cdn.simpleicons.org/${c.slug}`}
                alt={c.name}
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.nextSibling) e.target.nextSibling.style.display = 'inline';
                }}
                className="max-h-9 lg:max-h-11 w-auto object-contain opacity-95 group-hover:scale-110 transition-transform duration-300"
              />
              <span style={{ display: 'none' }} className="text-[#0F1C40]/70 font-semibold tracking-[0.15em] text-sm">{c.name.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
